// frontend/src/KlaviyoProfileCleanup/invalidShared.jsx
// Shared by the Stores Still Invalid and Clubs Needing Mapping tabs: the store picker dialog and the snapshot refresh.
import React, { useEffect, useState } from 'react';
import { FormLayout, Select } from '@shopify/polaris';
import { Modal } from '../ItAssets/common';
import { kpcApi } from './apiClient';
import { Alert, useKpc, when } from './common';

export function PickStore({ club, value, suggestion, current, note, stores, onClose, onSave, error }) {
  const options = [{ value: '', label: 'Choose a store…', disabled: true }, ...stores.map((s) => ({ value: s, label: s }))];
  const preset = current || (suggestion && suggestion.store);
  const [store, setStore] = useState(preset && stores.includes(preset) ? preset : '');
  return (
    <Modal title={club ? `Store for ${club}` : `Rule for “${value}”`} subtitle="Every corporate store from Lightspeed, plus soccerpost.com and any store a rule or club already points at." onClose={onClose} focusFirst
      footer={<><button type="button" className="uh-btn" onClick={onClose}>Cancel</button><button type="button" className="uh-btn primary" disabled={!store || store === current} onClick={() => onSave(store)}>{current ? 'Change store' : club ? 'Create club rule' : 'Create rule'}</button></>}>
      <Alert>{error}</Alert>
      {note && <div className="uh-kpc-banner info">{note}</div>}
      <FormLayout><Select label="Local Store" options={options} value={store} onChange={setStore} requiredIndicator /></FormLayout>
    </Modal>
  );
}

/** Takes a new snapshot of Klaviyo's invalid segment and polls `reload` every 5 s until `data.taken_at` moves or 3 minutes pass. */
export function useSnapshotRefresh(data, reload, deps) {
  const { notify } = useKpc();
  const [refreshing, setRefreshing] = useState(null);   // { since, started } while a snapshot is being taken
  const [stale, setStale] = useState('');
  const [err, setErr] = useState('');
  const start = async () => {
    setErr(''); setStale('');
    try { await kpcApi.refreshInvalid(); setRefreshing({ since: data ? data.taken_at : null, started: Date.now() }); } catch (e) { setErr(e.message); }
  };
  useEffect(() => {
    if (!refreshing) return undefined;
    const t = setInterval(() => {
      if (Date.now() - refreshing.started > 180000) { setRefreshing(null); setStale('Still refreshing; try again in a minute'); } else reload();
    }, 5000);
    return () => clearInterval(t);
  }, [refreshing, reload, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (refreshing && data && data.taken_at !== refreshing.since) { setRefreshing(null); notify('Snapshot refreshed'); }
  }, [data, refreshing, notify]);
  const status = refreshing ? 'Refreshing, back in about a minute' : data ? `${Number(data.count).toLocaleString()} profiles in “Utility - Invalid Local Stores” · refreshed ${when(data.taken_at) || 'never'}` : '';
  const button = <button type="button" className="uh-btn slim" disabled={!!refreshing} onClick={start}>{refreshing ? 'Refreshing…' : 'Refresh'}</button>;
  return { status, button, message: err || stale };
}
